"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toGrpcWebMethodDefinition = exports.normalizeServiceDefinition = void 0;
const grpc_web_1 = require("./grpc-web");
const ts_proto_1 = require("./ts-proto");
/** @internal */
function normalizeServiceDefinition(definition) {
    if (grpc_web_1.isGrpcWebServiceDefinition(definition)) {
        return grpc_web_1.fromGrpcWebServiceDefinition(definition);
    }
    else if (ts_proto_1.isTsProtoServiceDefinition(definition)) {
        return ts_proto_1.fromTsProtoServiceDefinition(definition);
    }
    else {
        return definition;
    }
}
exports.normalizeServiceDefinition = normalizeServiceDefinition;
/** @internal */
function toGrpcWebMethodDefinition(definition) {
    const [, serviceName, methodName] = definition.path.split('/');
    return {
        service: {
            serviceName,
        },
        methodName,
        requestStream: definition.requestStream,
        responseStream: definition.responseStream,
        requestType: class {
            constructor() {
                throw new Error('Unexpected instantiation');
            }
            static deserializeBinary(bytes) {
                return definition.requestDeserialize(bytes);
            }
        },
        responseType: class {
            constructor() {
                throw new Error('Unexpected instantiation');
            }
            static deserializeBinary(bytes) {
                return definition.responseDeserialize(bytes);
            }
        },
    };
}
exports.toGrpcWebMethodDefinition = toGrpcWebMethodDefinition;
//# sourceMappingURL=index.js.map